<template lang='pug'>
  .basic.modal.wrapper.component
    close-button( @click.native='$emit("close")' )
    slot
</template>

<script>
  import CloseButton from '@/components/buttons/close'

  export default {
    name: 'basic.modal.wrapper',

    components: {
      CloseButton
    }
  }
</script>

<style scoped lang="stylus">
  .wrapper
    border-radius 11px
    max-width 480px
    position relative
    border 3px solid white
    &.max-640
      max-width 640px
    &.max-800
      max-width 800px
        
    .close
      position absolute
      right -9px
      top -10px
      color rgb( 240 240 240 )
      background rgb( 192 192 192 )
</style>